import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SoftInput from "components/SoftInput";
import { columns } from "pages/AntTableData/shortlistCandidateData";
import { Table, Tooltip } from "antd";
import PropTypes from "prop-types";
import SoftSelect from "components/SoftSelect";
import Modal from "react-bootstrap/Modal";
import "./csStyle.css";
import axios from "axios";
import SoftButton from "components/SoftButton";
import SoftBadge from "components/SoftBadge";
import { Icon } from "@iconify/react";
import { Button } from "@mui/material";
import { MdMoreHoriz } from "react-icons/md";
import Swal from "sweetalert2";
import moment from "moment/moment";
import refreshBtn from "../../assets/images/logos/refresh_btn.png";
import Select from "react-select";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useSearchParams } from "react-router-dom";

const ViewCandidates = (props) => {
  const {
    orgname,
    jobrole,
    data,
    buttonFunc,
    orgId,
    jobId,
    shortData,
    setShortData,
    handleShortlistedApi,
    isLoading,
  } = props;

  console.log("org and job ids:", { orgid: orgId, jobid: jobId });
  const [searchParams, setSearchParams] = useSearchParams();
  const [actionModal, setactionModal] = useState(false);
  const [actionModal1, setactionModal1] = useState(false);
  const [applyModal, setApplyModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [rowJobId, setRowJobId] = useState([]);
  const [rowMob, setRowMob] = useState([]);
  const [rowName, setRowName] = useState([]);
  const [jobdesignation, setJobdesignation] = useState([]);
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [cosList, setConsList] = useState([]);
  const [candid, setCandid] = useState([]);
  const [cosId, setCosId] = useState({});
  const [name, setName] = useState("");
  const [searchData, setSearchData] = useState([data]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const registerID = sessionStorage.getItem("register_id");
  const localStorage_jobId = sessionStorage.getItem("job_id");
  const localStorage_orgId = sessionStorage.getItem("org_id");
  const localStorage_jobRole = sessionStorage.getItem("job_role");
  const localStorage_orgName = sessionStorage.getItem("org_name");
  const localStorage_toggle = sessionStorage.getItem("shortlisted_local");
  console.log(
    "localstorage",
    localStorage_jobId,
    localStorage_orgId,
    localStorage_toggle,
    localStorage_orgName,
    localStorage_jobRole
  );
  // const [buutonToggle, setButtonToggle] = useState(false);
  // const [val,setVal] = useState('');
  // const [searchData,setSearchData] = useState(data);
  // const rowJobId = [];
  console.log("shortdata ", shortData);
  console.log("data ", data);
  console.log(actionModal1);
  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    console.log("selected rows", selectedRows);
    setSelectedRowKeys(newSelectedRowKeys);
    // selectedRows.map((ele, i) => {
    //   console.log("element ", ele);
    //   // setRowJobId((item) => {
    //   //   [...item, ele.key];
    //   // });

    //   // rowJobId.concat([ele.jobid]);
    // });
    setRowJobId(selectedRows.map((item, i) => item.jobid));
    setRowMob(selectedRows.map((item, i) => item.phone));
    setRowName(selectedRows.map((item, i) => item.candidate_name));
    setCandid(selectedRows.map((item, i) => item.key));
    setJobdesignation(selectedRows.map((item, i) => item.job_role));
  };
  console.log("row jobid1", rowJobId);
  console.log("row mob", rowMob);
  console.log("row name", rowName);
  console.log("row jp id", jobdesignation);
  console.log("row keys", selectedRowKeys);
  console.log("broadcastdby id", orgId);
  console.log("canid", candid);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const stylesDD = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      // borderColor: state.isFocused ? "grey" : "red",
      fontSize: "14px",
      width: "200px",
      height: "41px",
    }),
    option: (base) => ({
      ...base,
      // border: `1px dotted red`,
      height: "100%",
      fontSize: "14px",
    }),
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  // console.log("rowJobid 2", rowJobId);
  const hasSelected = selectedRowKeys.length > 0;
  // const candidateTable = sessionStorage.getItem("candidate_shortlisted_data");
  console.log("can data ", shortData);
  // const roleSelected = sessionStorage.getItem("role_selected");
  // const orgName = sessionStorage.getItem("org_selected");
  // console.log("candudate table", candidateTable);
  // const fetchShortlistedCandidate = () => {
  //   const params = {
  //     orgid: orgId,
  //     // orgid: "SMR-JP-328154",
  //     jobid: "",
  //   };
  //   const paramString = new URLSearchParams(params).toString();
  //   axios
  //     // .get(`${ngrokLink}/superadmin/candidatesearch/jobrolelist?${paramString}`)
  //     .get(
  //       `${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/candidatesearch/shortlistedcandidate?${paramString}`
  //     )
  //     .then((res) => {
  //       // setDistrict(res.data);
  //       console.log("Role tabel", res.data["JobPost_List"]);
  //       //  setRoleList(res.data["JobPost_List"]);
  //       navigate("/search/newsearch/recommend-search/allshortlist/viewCandidates");
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // useEffect(() => {
  //   fetchShortlistedCandidate();
  // }, [orgId]);
  console.log(orgname);
  const handleConsPostData = () => {
    axios
      .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/counsellor/associate/assign`, {
        orgid: orgId,
        jobid: rowJobId,
        candid: candid,
        counid: cosId.value,
        // assignee_id: sessionStorage.getItem("register_id"),
        assignee_id: registerID,
      })
      .then((res) => {
        console.log(res.data);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data["User Message"],
          showConfirmButton: false,
          position: "top",
          timer: 3000,
        }).then(() => {
          // onSelectChange();
          navigate("/jobprovidere2e/shortlisted");
        });
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: err.response.data["Developer Message"]
            ? err.response.data["Developer Message"]
            : "Oops...",
          // text: res.data["User Message"],
          text: err.response.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };

  const handleConsPost = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/counsellor/dashboard/fetch/details`, {
        params: { createdby: sessionStorage.getItem("register_id") },
      })
      .then((res) => {
        setConsList(res.data.counsellor_details);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const viewList = [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Whatsapp List",
      value: "Whatsapp List",
    },
    {
      label: "Counsellor List",
      value: "Counsellor List",
    },
  ];
  const round = [
    { isDone: true },
    { isDone: true },
    { isDone: false },
    { isDone: false },
    { isDone: false },
  ];
  const columns3 = [
    {
      title: "Candidate Name",
      width: 200,
      // dataIndex: "candidate_name",
      key: "candidate_name",
      fixed: "left",
      //   sorter: true,
      render: (text, record) => <p>{`${text.first_name}` + " " + `${text.last_name}`}</p>,
      sorter: { compare: (a, b) => a?.candidate_name.localeCompare(b?.candidate_name) },
    },

    {
      title: "Phone",
      dataIndex: "mobile",
      key: "2",
      fixed: "left",
      sorter: { compare: (a, b) => a?.mobile - b?.mobile },
    },
    {
      title: "Counsellor Name",
      dataIndex: "counsellor_name",
      key: "2",
      sorter: { compare: (a, b) => a?.counsellor_name.localeCompare(b?.counsellor_name) },
    },
    {
      title: "Application Stage",
      // dataIndex: "stage",
      width: 250,
      key: "2",
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* {round.map((ele, i) => ( */}
          <div
            // key={i + 1}
            className={
              text.stage === 0 && text.score === "completed"
                ? "completed-class"
                : text.stage > 0
                ? "completed-class"
                : text.stage === "" && text.completion_status === "in_progress"
                ? "in_progress-class"
                : text.stage === 0 && text.completion_status === "in_progress"
                ? "in_progress-class"
                : text.stage === "" && text.completion_status === "rejected"
                ? "rejected-class"
                : "default"
            }
            // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
          ></div>
          {/* ))} */}
          <div
            // key={i + 1}
            className={
              text.stage === 0 && text.completion_status === "completed"
                ? "in_progress-class"
                : text.stage === 1 && text.completion_status === "completed"
                ? "completed-class"
                : text.stage === 0 && text.completion_status === "rejected"
                ? "rejected-class"
                : text.stage === 1 && text.completion_status === "rejected"
                ? "completed-class"
                : text.stage === 1 && text.completion_status === "in_progress"
                ? "completed-class"
                : text.stage > 1
                ? "completed-class"
                : text.stage === 0 && text.completion_status === "in_progress"
                ? "in_progress-class"
                : text.stage === 1 && text.completion_status === "rejected"
                ? "rejected-class"
                : "default"
            }
            // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
          ></div>
          <div
            // key={i + 1}
            className={
              text.stage === 1 && text.completion_status === "completed"
                ? "in_progress-class"
                : text.stage === 2 && text.completion_status === "completed"
                ? "completed-class"
                : text.stage === 1 && text.completion_status === "rejected"
                ? "rejected-class"
                : text.stage === 2 && text.completion_status === "rejected"
                ? "completed-class"
                : text.stage === 2 && text.completion_status === "in_progress"
                ? "completed-class"
                : text.stage > 2
                ? "completed-class"
                : text.stage === 1 && text.completion_status === "in_progress"
                ? "in_progress-class"
                : text.stage === 2 && text.completion_status === "rejected"
                ? "rejected-class"
                : "default"
            }
            // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
          ></div>
          <div
            // key={i + 1}
            className={
              text.stage === 2 && text.completion_status === "completed"
                ? "in_progress-class"
                : text.stage === 3 && text.completion_status === "completed"
                ? "completed-class"
                : text.stage === 2 && text.completion_status === "rejected"
                ? "rejected-class"
                : text.stage === 3 && text.completion_status === "rejected"
                ? "completed-class"
                : text.stage === 3 && text.completion_status === "in_progress"
                ? "completed-class"
                : text.stage > 3
                ? "completed-class"
                : text.stage === 2 && text.completion_status === "in_progress"
                ? "in_progress-class"
                : text.stage === 3 && text.completion_status === "rejected"
                ? "rejected-class"
                : "default"
            }
            // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
          ></div>
          <div
            // key={i + 1}
            className={
              text.stage === 3 && text.completion_status === "completed"
                ? "in_progress-class"
                : text.stage === 4 && text.completion_status === "completed"
                ? "completed-class"
                : text.stage === 3 && text.completion_status === "rejected"
                ? "rejected-class"
                : text.stage === 4 && text.completion_status === "rejected"
                ? "completed-class"
                : text.stage === 4 && text.completion_status === "in_progress"
                ? "completed-class"
                : text.stage > 4
                ? "completed-class"
                : text.stage === 3 && text.completion_status === "in_progress"
                ? "in_progress-class"
                : text.stage === 4 && text.completion_status === "rejected"
                ? "rejected-class"
                : "default"
            }
            // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
          ></div>
          <div
            // key={i + 1}
            className={
              text.stage === 4 && text.completion_status === "completed"
                ? "in_progress-class"
                : text.stage === 5 && text.completion_status === "completed"
                ? "completed-class"
                : text.stage === 4 && text.completion_status === "rejected"
                ? "rejected-class"
                : text.stage === 5 && text.completion_status === "rejected"
                ? "completed-class"
                : text.stage === 5 && text.completion_status === "in_progress"
                ? "completed-class"
                : text.stage > 5
                ? "completed-class"
                : text.stage === 4 && text.completion_status === "in_progress"
                ? "in_progress-class"
                : text.stage === 5 && text.completion_status === "rejected"
                ? "rejected-class"
                : "default"
            }
            // style={{ width: "8px", height: "8px", background: "blue", borderRadius: "50%" }}
          ></div>
        </div>
      ),
      // render: (text, record) => (
      //   <div style={{ display: "flex", justifyContent: "space-between" }}>
      //     {round.map(
      //       (ele, i) => (
      //         console.log("application stage", ele),
      //         (
      //           <div
      //             key={i + 1}
      //             className={
      //               shortData.stage === 0 && app_status === "completed"
      //                 ? "completed-class"
      //                 : shortData.stage === 0 && app_status === "inprocess"
      //                 ? "inprocess-class"
      //                 : shortData.stage === 0 && app_status === "rejected"
      //                 ? "rejected-class"
      //                 : "default"
      //             }
      //           ></div>
      //         )
      //       )
      //     )}
      //   </div>
      // ),
    },
    {
      title: "Status",
      // dataIndex: "status",
      key: "2",
      width: 300,
      render: (text) => (
        <span
          style={{
            backgroundColor:
              text.completion_status === "completed"
                ? "#BDFDC8"
                : text.completion_status === "rejected"
                ? "#EFD6FF"
                : "#FFE1C3",
            color:
              text.completion_status === "completed"
                ? "#049C2F"
                : text.completion_status === "rejected"
                ? "#62049C"
                : "#EA7500",
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingLeft: "10px",
            paddingRight: "10px",
            borderRadius: "50px",
          }}
        >
          {text.candidate_status}
        </span>
      ),
    },
    // { title: "Location", dataIndex: "taluka", key: "2" },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: { compare: (a, b) => a?.state.localeCompare(b?.state) },
    },
    {
      title: "District",
      dataIndex: "district",
      key: "district",
      sorter: { compare: (a, b) => a?.district.localeCompare(b?.district) },
    },
    {
      title: "Taluka",
      dataIndex: "taluka",
      key: "4",
      sorter: { compare: (a, b) => a?.taluka.localeCompare(b?.taluka) },
    },
    {
      title: "Skills",
      // dataIndex: "skills",
      key: "2",
      render: (text) => (
        <span>{text.skills !== null ? text.skills : text.job_role}</span>
        // <span>{text.job_role}</span>
      ),
    },
    { title: "Feedbacks", dataIndex: "feedback", key: "2" },
  ];

  const columns = [
    {
      title: "Candidate Name",
      width: 150,
      // dataIndex: "candidate_name",
      key: "candidate_name",
      fixed: "left",
      //   sorter: true,
      sorter: { compare: (a, b) => a?.first_name?.localeCompare(b?.first_name) },
      render: (text, record) => <p>{`${text.first_name}` + " " + `${text.last_name}`}</p>,
    },
    {
      title: "Phone",
      //   width: 100,
      dataIndex: "mobile",
      key: "mobile",
      sorter: { compare: (a, b) => a.mobile - b.mobile },
      fixed: "left",
      //   sorter: true,
    },
    {
      title: "Roles",
      dataIndex: "job_role",
      key: "2",
      sorter: { compare: (a, b) => a?.job_role?.localeCompare(b?.job_role) },
    },
    {
      title: "Job Title",
      dataIndex: "job_title",
      key: "10",
      sorter: { compare: (a, b) => a?.job_title?.localeCompare(b?.job_title) },
    },

    // { title: "Qualification", dataIndex: "qualification", key: "1" },
    // { title: 'Modified On', dataIndex: 'modified_on', key: '2' },

    {
      title: "Score",
      // dataIndex: "score",
      sorter: { compare: (a, b) => a.score - b.score },
      key: "6",
      render: (text) => (
        <span
          style={{
            backgroundColor:
              text.score > 80
                ? "#B7F4BB"
                : text.score < 80 && text.score >= 45
                ? "#EFB7F4"
                : "#FFD3D3",
            color:
              text.score > 80
                ? "#049C2F"
                : text.score < 80 && text.score >= 45
                ? "#62049C"
                : "#FF0000",
            paddingTop: "3px",
            paddingBottom: "3px",
            paddingLeft: "15px",
            paddingRight: "15px",
            borderRadius: "10px",
          }}
        >
          {text.score >= 80
            ? "Excellent Match"
            : text.score < 80 && text >= 45
            ? "Medium Match"
            : "Poor Match"}
        </span>
      ),
      // render: (text, record) => (
      //   <span>
      //     <SoftBadge
      //       variant="contained"
      //       color={text >= 80 ? "success" : text < 80 && text >= 45 ? "warning" : "error"}
      //       size="xs"
      //       badgeContent={
      //         text >= 80
      //           ? "Excellent Match"
      //           : text < 80 && text >= 45
      //           ? "Medium Match"
      //           : "Poor Match"
      //       }
      //       container
      //     />
      //   </span>
      // ),
    },
    {
      title: "Last Active",
      dataIndex: "last_activedate",
      key: "5",
      sorter: {
        compare: (a, b) =>
          moment(a.last_activedate, "DD-MM-YYYY") - moment(b.last_activedate, "DD-MM-YYYY"),
      },
    },
    // {
    //   title: "Status",
    //   // dataIndex: "status",
    //   sorter: { compare: (a, b) => a.status - b.status },
    //   key: "7",
    //   render: (text) => (
    //     <div
    //       style={{
    //         backgroundColor:
    //           text.wa_status === "sent"
    //             ? "#C0CFFF"
    //             : // : text.status === "rejected"
    //               // ? "#EFD6FF"
    //               "#E9E9E9",
    //         color:
    //           text.wa_status === "sent"
    //             ? "#3B5092"
    //             : // : text.status === "rejected"
    //               // ? "#62049C"
    //               "#767676",
    //         display: "flex",
    //         flexDirection: "row",
    //         justifyContent: "center",
    //         alignContent: "center",
    //         paddingTop: "5px",
    //         paddingBottom: "5px",
    //         paddingLeft: "5px",
    //         paddingRight: "10px",
    //         borderRadius: "10px",
    //         gap: "5px",
    //         width: "106px",
    //       }}
    //     >
    //       {/* {text.status} */}
    //       {/* <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}> */}
    //       <p style={{ marginBottom: "0px" }}>
    //         {text.wa_status === "sent" ? (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             viewBox="0 0 16 16"
    //             fill="none"
    //           >
    //             <path
    //               d="M9.39455 0.812325L8.77549 0.285366C8.3285 -0.0951222 7.6715 -0.0951218 7.22451 0.285366L6.60545 0.812325C6.33165 1.0454 5.96753 1.14296 5.61388 1.07802L4.81428 0.931185C4.23693 0.825167 3.66795 1.15367 3.47109 1.70668L3.19845 2.47257C3.07786 2.81131 2.81131 3.07786 2.47257 3.19845L1.70668 3.47109C1.15367 3.66795 0.825167 4.23693 0.931186 4.81428L1.07802 5.61388C1.14296 5.96753 1.0454 6.33165 0.812325 6.60545L0.285366 7.22451C-0.0951222 7.6715 -0.0951218 8.3285 0.285366 8.77549L0.812325 9.39455C1.0454 9.66835 1.14296 10.0325 1.07802 10.3861L0.931185 11.1857C0.825167 11.7631 1.15367 12.3321 1.70668 12.5289L2.47257 12.8016C2.81131 12.9221 3.07786 13.1887 3.19845 13.5274L3.47109 14.2933C3.66795 14.8463 4.23693 15.1748 4.81428 15.0688L5.61388 14.922C5.96753 14.857 6.33165 14.9546 6.60545 15.1877L7.22451 15.7146C7.6715 16.0951 8.3285 16.0951 8.77549 15.7146L9.39455 15.1877C9.66835 14.9546 10.0325 14.857 10.3861 14.922L11.1857 15.0688C11.7631 15.1748 12.3321 14.8463 12.5289 14.2933L12.8016 13.5274C12.9221 13.1887 13.1887 12.9221 13.5274 12.8016L14.2933 12.5289C14.8463 12.3321 15.1748 11.7631 15.0688 11.1857L14.922 10.3861C14.857 10.0325 14.9546 9.66835 15.1877 9.39455L15.7146 8.77549C16.0951 8.3285 16.0951 7.6715 15.7146 7.22451L15.1877 6.60545C14.9546 6.33165 14.857 5.96753 14.922 5.61388L15.0688 4.81428C15.1748 4.23693 14.8463 3.66795 14.2933 3.47109L13.5274 3.19845C13.1887 3.07786 12.9221 2.81131 12.8016 2.47257L12.5289 1.70668C12.3321 1.15367 11.7631 0.825167 11.1857 0.931186L10.3861 1.07802C10.0325 1.14296 9.66835 1.0454 9.39455 0.812325Z"
    //               fill="#849DED"
    //             />
    //             <path
    //               d="M12.5354 5.22656L6.30208 11.4399L3.46875 8.61565"
    //               stroke="#3B5092"
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //             />
    //           </svg>
    //         ) : text.wa_status === "no status" ? (
    //           ""
    //         ) : (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="20"
    //             height="20"
    //             viewBox="0 0 16 16"
    //             fill="none"
    //           >
    //             <path
    //               d="M7.22451 0.285366C7.6715 -0.0951218 8.3285 -0.0951222 8.77549 0.285366L9.39455 0.812325C9.66835 1.04539 10.0325 1.14296 10.3861 1.07802L11.1857 0.931186C11.7631 0.825167 12.3321 1.15367 12.5289 1.70668L12.8016 2.47257C12.9221 2.81131 13.1887 3.07786 13.5274 3.19845L14.2933 3.47109C14.8463 3.66795 15.1748 4.23693 15.0688 4.81428L14.922 5.61388C14.857 5.96753 14.9546 6.33165 15.1877 6.60545L15.7146 7.22451C16.0951 7.6715 16.0951 8.3285 15.7146 8.77549L15.1877 9.39455C14.9546 9.66835 14.857 10.0325 14.922 10.3861L15.0688 11.1857C15.1748 11.7631 14.8463 12.3321 14.2933 12.5289L13.5274 12.8016C13.1887 12.9221 12.9221 13.1887 12.8016 13.5274L12.5289 14.2933C12.3321 14.8463 11.7631 15.1748 11.1857 15.0688L10.3861 14.922C10.0325 14.857 9.66835 14.9546 9.39455 15.1877L8.77549 15.7146C8.3285 16.0951 7.6715 16.0951 7.22451 15.7146L6.60545 15.1877C6.33165 14.9546 5.96753 14.857 5.61388 14.922L4.81428 15.0688C4.23693 15.1748 3.66795 14.8463 3.47109 14.2933L3.19845 13.5274C3.07786 13.1887 2.81131 12.9221 2.47257 12.8016L1.70668 12.5289C1.15367 12.3321 0.825167 11.7631 0.931185 11.1857L1.07802 10.3861C1.14296 10.0325 1.0454 9.66835 0.812325 9.39455L0.285366 8.77549C-0.0951218 8.3285 -0.0951222 7.6715 0.285366 7.22451L0.812325 6.60545C1.04539 6.33165 1.14296 5.96753 1.07802 5.61388L0.931186 4.81428C0.825167 4.23693 1.15367 3.66795 1.70668 3.47109L2.47257 3.19845C2.81131 3.07786 3.07786 2.81131 3.19845 2.47257L3.47109 1.70668C3.66795 1.15367 4.23693 0.825167 4.81428 0.931185L5.61388 1.07802C5.96753 1.14296 6.33165 1.0454 6.60545 0.812325L7.22451 0.285366Z"
    //               fill="#C6C6C6"
    //             />
    //             <path
    //               d="M7.70864 10.0036V7.62992H8.5982C9.20843 7.62992 9.65965 7.46827 9.95187 7.14498C10.2527 6.82169 10.4031 6.42608 10.4031 5.95816C10.4031 5.60934 10.33 5.31157 10.1839 5.06485C10.0378 4.80962 9.83155 4.61819 9.56511 4.49058C9.30727 4.35446 9.01075 4.2864 8.67555 4.2864C8.28878 4.2864 7.95359 4.36722 7.66996 4.52886C7.39493 4.682 7.18006 4.89469 7.02535 5.16694C6.87065 5.43068 6.79329 5.73696 6.79329 6.08577H5.60721C5.60721 5.58382 5.71895 5.11589 5.94241 4.682C6.17447 4.24811 6.51826 3.89504 6.97378 3.6228C7.42931 3.35055 7.99656 3.21443 8.67555 3.21443C9.27718 3.21443 9.79287 3.33779 10.2226 3.58451C10.6609 3.82273 10.9961 4.14602 11.2282 4.55439C11.4689 4.95425 11.5892 5.39665 11.5892 5.88159V6.03472C11.5892 6.51116 11.4732 6.9493 11.2411 7.34916C11.009 7.74902 10.6609 8.06806 10.1968 8.30628C9.7413 8.53598 9.17834 8.65084 8.50795 8.65084L8.97207 8.06381L8.94629 10.0036H7.70864ZM7.57971 12.7856V11.2287H9.07521V12.7856H7.57971Z"
    //               fill="#767676"
    //             />
    //           </svg>
    //         )}
    //       </p>
    //       <p style={{ marginBottom: "0px" }}>
    //         {text.wa_status === "sent"
    //           ? "Sent"
    //           : text.wa_status === "no status"
    //           ? "No status"
    //           : "Yet to Sent"}
    //       </p>
    //       {/* </div> */}
    //     </div>
    //   ),
    //   ellipsis: {
    //     showTitle: false,
    //   },
    //   // render: (text) => (
    //   //   <span>
    //   //     <SoftBadge
    //   //       variant="contained"
    //   //       color={text.status === "sent" ? "seconday" : "dark"}
    //   //       size="xs"
    //   //       badgeContent={text.status === "sent" ? "Sent" : "Yet to send"}
    //   //       container
    //   //     />
    //   //   </span>
    //   //   // <Tooltip placement="topLeft" title={text.status}>
    //   //   //   {text.status}
    //   //   // </Tooltip>
    //   // ),
    // },
    {
      title: "Response",
      // dataIndex: "status",
      sorter: { compare: (a, b) => a.response - b.response },
      key: "7",
      render: (text) => (
        <span
          style={{
            backgroundColor:
              text.response === "interested"
                ? "#BDFDC8"
                : text.response === "not interested"
                ? "#EFD6FF"
                : "#FFE1C3",
            color:
              text.response === "interested"
                ? "#049C2F"
                : text.response === "not interested"
                ? "#62049C"
                : "#EA7500",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignContent: "center",
            paddingTop: "5px",
            paddingBottom: "5px",
            // paddingTop: "3px",
            // paddingBottom: "3px",
            // paddingLeft: "15px",
            // paddingRight: "15px",
            borderRadius: "10px",
            width: "106px",
          }}
        >
          {text.response === "interested"
            ? "Interested"
            : text.response === "not interested"
            ? "Not Interested"
            : "No Response"}
        </span>
      ),
      // render: (text, record) => (
      //   <span>
      //     <SoftBadge
      //       variant="contained"
      //       color={text.response === "interested" ? "success" : "error"}
      //       size="xs"
      //       badgeContent={
      //         text.response === "interested"
      //           ? "Interested"
      //           : text.response === "not interested"
      //           ? "Not Interested"
      //           : "No Response"
      //       }
      //       container
      //     />
      //   </span>
      // ),
    },
    {
      title: "Location",
      dataIndex: "taluka",
      key: "4",
      sorter: { compare: (a, b) => a?.taluka.localeCompare(b?.taluka) },
    },
    // { title: "Column 7", dataIndex: "address", key: "7" },
    // { title: "Column 8", dataIndex: "address", key: "8" },

    {
      title: "Action",
      key: "operation",
      // fixed: "right",
      width: 80,
      // render: () => <MdMoreHoriz />,
      render: () => (
        <div className="edit_icons">
          <div className="dropdown">
            <Button
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <Icon icon="ion:ellipsis-horizontal" color="black" />
            </Button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <p
                  className="dropdown-item"
                  // href="#EditUser"
                  onClick={() => {
                    console.log("whatsapp verification modal");
                    setApplyModal(true);
                  }}
                >
                  Whatsapp Verification
                </p>
              </li>
              <li>
                <p
                  className="dropdown-item"
                  // href="#Deleteuser"
                  onClick={() => {
                    console.log("counsellors modal");
                    // navigate("/search/newsearch/recommend-search/allshortlist/viewCandidates");
                  }}
                >
                  Counsellors
                </p>
              </li>
              <li>
                <p
                  className="dropdown-item"
                  // href="#Deleteuser"
                  onClick={() => {
                    console.log("sms verification");
                  }}
                >
                  SMS Verification
                </p>
              </li>
            </ul>
          </div>
        </div>
      ),
    },
  ];

  const columns2 = [
    {
      title: "Candidate Names",
      width: 200,
      dataIndex: "candidate_name",
      key: "candidate_name",
      fixed: "left",
      //   sorter: true,
      sorter: { compare: (a, b) => a?.candidate_name?.localeCompare(b?.candidate_name) },
    },
    {
      title: "Phone",
      width: 150,
      dataIndex: "phone",
      key: "phone",
      fixed: "left",
      sorter: { compare: (a, b) => a?.phone - b?.phone },
      //   fixed: 'left',
      //   sorter: true,
    },
    {
      title: "Roles",
      dataIndex: "job_role",
      key: "2",
      width: 150,
      sorter: { compare: (a, b) => a?.job_role?.localeCompare(b?.job_role) },
    },

    { title: "Education", dataIndex: "education", key: "1", width: 150 },
    {
      title: "Modified On",
      dataIndex: "modified_on",
      key: "2",
      width: 150,
      sorter: {
        compare: (a, b) =>
          moment(a.modified_on, "DD-MM-YYYY") - moment(b.modified_on, "DD-MM-YYYY"),
      },
    },
    { title: "Skills", dataIndex: "skills", key: "3", width: 150 },

    {
      title: "State",
      dataIndex: "state",
      key: "state",
      width: 150,
      sorter: { compare: (a, b) => a?.state?.localeCompare(b?.state) },
    },
    {
      title: "District",
      dataIndex: "district",
      key: "district",
      width: 150,
      sorter: { compare: (a, b) => a?.district?.localeCompare(b?.district) },
    },
    {
      title: "Taluka",
      dataIndex: "taluka",
      key: "4",
      width: 150,
      sorter: { compare: (a, b) => a?.taluka?.localeCompare(b?.taluka) },
    },
    { title: "Data Source", dataIndex: "datasource", key: "datasource", width: 150 },
    {
      title: "Last Active",
      dataIndex: "last_active",
      key: "5",
      width: 150,
      sorter: {
        compare: (a, b) => moment(a.last_active, "DD-MM-YYYY") - moment(b.active, "DD-MM-YYYY"),
      },
    },
    {
      title: "Score",
      dataIndex: "score",
      sorter: { compare: (a, b) => a.score - b.score },
      key: "6",
      width: 150,
      // render: (text, record) => (
      //   <span>
      //     <SoftBadge
      //       variant="contained"
      //       color={text >= 80 ? "success" : text < 80 && text >= 45 ? "warning" : "error"}
      //       size="xs"
      //       badgeContent={
      //         text >= 80
      //           ? "Excellent Match"
      //           : text < 80 && text >= 45
      //           ? "Medium Match"
      //           : "Poor Match"
      //       }
      //       container
      //     />
      //   </span>
      // ),
      render: (text) => (
        <span
          style={{
            backgroundColor:
              text.score > 80
                ? "#B7F4BB"
                : text.score < 80 && text.score >= 45
                ? "#EFB7F4"
                : "#FFD3D3",
            color:
              text.score > 80
                ? "#049C2F"
                : text.score < 80 && text.score >= 45
                ? "#62049C"
                : "#FF0000",
            paddingTop: "3px",
            paddingBottom: "3px",
            paddingLeft: "15px",
            paddingRight: "15px",
            borderRadius: "10px",
          }}
        >
          {text.score >= 80
            ? "Excellent Match"
            : text.score < 80 && text >= 45
            ? "Medium Match"
            : "Poor Match"}
        </span>
      ),
    },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   sorter: { compare: (a, b) => a.status - b.status },
    //   key: "7",
    //   render: (text, record) => (
    //     <span>
    //       <SoftBadge
    //         variant="contained"
    //         color={text >= 80 ? "success" : text < 80 && text >= 45 ? "warning" : "error"}
    //         size="xs"
    //         badgeContent={
    //           text >= 80 ? "Excellent Match" : text < 80 && text >= 45 ? "Medium Match" : "Poor Match"
    //         }
    //         container
    //       />
    //     </span>
    //   ),
    // },

    // { title: "Column 7", dataIndex: "address", key: "7" },
    // { title: "Column 8", dataIndex: "address", key: "8" },
    {
      title: "Status",
      // dataIndex: "status",
      sorter: { compare: (a, b) => a.broadcast_status - b.broadcast_status },
      key: "7",
      width: 150,
      render: (text) => (
        <div
          style={{
            backgroundColor:
              text.broadcast_status === "0"
                ? "#E9E9E9"
                : text.broadcast_status === "1"
                ? "#EFB7F4"
                : text.broadcast_status === "2"
                ? "#C0CFFF"
                : "#E9E9E9",
            color:
              text.broadcast_status === "0"
                ? "#767676"
                : text.broadcast_status === "1"
                ? "#62049C"
                : text.broadcast_status === "2"
                ? "#3B5092"
                : "#767676",
            // text.broadcast_status === "sent"
            //   ? "#3B5092"
            //   : // : text.status === "rejected"
            //     // ? "#62049C"
            //     "#767676",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignContent: "center",
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingLeft: "5px",
            paddingRight: "10px",
            borderRadius: "10px",
            gap: "5px",
            // width: "106px",
          }}
        >
          {/* {text.status} */}
          {console.log("status ", text.broadcast_status)}
          {/* <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}> */}
          <p style={{ marginBottom: "0px" }}>
            {text.broadcast_status === "0" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M7.22451 0.285366C7.6715 -0.0951218 8.3285 -0.0951222 8.77549 0.285366L9.39455 0.812325C9.66835 1.04539 10.0325 1.14296 10.3861 1.07802L11.1857 0.931186C11.7631 0.825167 12.3321 1.15367 12.5289 1.70668L12.8016 2.47257C12.9221 2.81131 13.1887 3.07786 13.5274 3.19845L14.2933 3.47109C14.8463 3.66795 15.1748 4.23693 15.0688 4.81428L14.922 5.61388C14.857 5.96753 14.9546 6.33165 15.1877 6.60545L15.7146 7.22451C16.0951 7.6715 16.0951 8.3285 15.7146 8.77549L15.1877 9.39455C14.9546 9.66835 14.857 10.0325 14.922 10.3861L15.0688 11.1857C15.1748 11.7631 14.8463 12.3321 14.2933 12.5289L13.5274 12.8016C13.1887 12.9221 12.9221 13.1887 12.8016 13.5274L12.5289 14.2933C12.3321 14.8463 11.7631 15.1748 11.1857 15.0688L10.3861 14.922C10.0325 14.857 9.66835 14.9546 9.39455 15.1877L8.77549 15.7146C8.3285 16.0951 7.6715 16.0951 7.22451 15.7146L6.60545 15.1877C6.33165 14.9546 5.96753 14.857 5.61388 14.922L4.81428 15.0688C4.23693 15.1748 3.66795 14.8463 3.47109 14.2933L3.19845 13.5274C3.07786 13.1887 2.81131 12.9221 2.47257 12.8016L1.70668 12.5289C1.15367 12.3321 0.825167 11.7631 0.931185 11.1857L1.07802 10.3861C1.14296 10.0325 1.0454 9.66835 0.812325 9.39455L0.285366 8.77549C-0.0951218 8.3285 -0.0951222 7.6715 0.285366 7.22451L0.812325 6.60545C1.04539 6.33165 1.14296 5.96753 1.07802 5.61388L0.931186 4.81428C0.825167 4.23693 1.15367 3.66795 1.70668 3.47109L2.47257 3.19845C2.81131 3.07786 3.07786 2.81131 3.19845 2.47257L3.47109 1.70668C3.66795 1.15367 4.23693 0.825167 4.81428 0.931185L5.61388 1.07802C5.96753 1.14296 6.33165 1.0454 6.60545 0.812325L7.22451 0.285366Z"
                  fill="#C6C6C6"
                />
                <path
                  d="M7.70864 10.0036V7.62992H8.5982C9.20843 7.62992 9.65965 7.46827 9.95187 7.14498C10.2527 6.82169 10.4031 6.42608 10.4031 5.95816C10.4031 5.60934 10.33 5.31157 10.1839 5.06485C10.0378 4.80962 9.83155 4.61819 9.56511 4.49058C9.30727 4.35446 9.01075 4.2864 8.67555 4.2864C8.28878 4.2864 7.95359 4.36722 7.66996 4.52886C7.39493 4.682 7.18006 4.89469 7.02535 5.16694C6.87065 5.43068 6.79329 5.73696 6.79329 6.08577H5.60721C5.60721 5.58382 5.71895 5.11589 5.94241 4.682C6.17447 4.24811 6.51826 3.89504 6.97378 3.6228C7.42931 3.35055 7.99656 3.21443 8.67555 3.21443C9.27718 3.21443 9.79287 3.33779 10.2226 3.58451C10.6609 3.82273 10.9961 4.14602 11.2282 4.55439C11.4689 4.95425 11.5892 5.39665 11.5892 5.88159V6.03472C11.5892 6.51116 11.4732 6.9493 11.2411 7.34916C11.009 7.74902 10.6609 8.06806 10.1968 8.30628C9.7413 8.53598 9.17834 8.65084 8.50795 8.65084L8.97207 8.06381L8.94629 10.0036H7.70864ZM7.57971 12.7856V11.2287H9.07521V12.7856H7.57971Z"
                  fill="#767676"
                />
              </svg>
            ) : text.broadcast_status === "1" ? (
              ""
            ) : text.broadcast_status === "2" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M9.39455 0.812325L8.77549 0.285366C8.3285 -0.0951222 7.6715 -0.0951218 7.22451 0.285366L6.60545 0.812325C6.33165 1.0454 5.96753 1.14296 5.61388 1.07802L4.81428 0.931185C4.23693 0.825167 3.66795 1.15367 3.47109 1.70668L3.19845 2.47257C3.07786 2.81131 2.81131 3.07786 2.47257 3.19845L1.70668 3.47109C1.15367 3.66795 0.825167 4.23693 0.931186 4.81428L1.07802 5.61388C1.14296 5.96753 1.0454 6.33165 0.812325 6.60545L0.285366 7.22451C-0.0951222 7.6715 -0.0951218 8.3285 0.285366 8.77549L0.812325 9.39455C1.0454 9.66835 1.14296 10.0325 1.07802 10.3861L0.931185 11.1857C0.825167 11.7631 1.15367 12.3321 1.70668 12.5289L2.47257 12.8016C2.81131 12.9221 3.07786 13.1887 3.19845 13.5274L3.47109 14.2933C3.66795 14.8463 4.23693 15.1748 4.81428 15.0688L5.61388 14.922C5.96753 14.857 6.33165 14.9546 6.60545 15.1877L7.22451 15.7146C7.6715 16.0951 8.3285 16.0951 8.77549 15.7146L9.39455 15.1877C9.66835 14.9546 10.0325 14.857 10.3861 14.922L11.1857 15.0688C11.7631 15.1748 12.3321 14.8463 12.5289 14.2933L12.8016 13.5274C12.9221 13.1887 13.1887 12.9221 13.5274 12.8016L14.2933 12.5289C14.8463 12.3321 15.1748 11.7631 15.0688 11.1857L14.922 10.3861C14.857 10.0325 14.9546 9.66835 15.1877 9.39455L15.7146 8.77549C16.0951 8.3285 16.0951 7.6715 15.7146 7.22451L15.1877 6.60545C14.9546 6.33165 14.857 5.96753 14.922 5.61388L15.0688 4.81428C15.1748 4.23693 14.8463 3.66795 14.2933 3.47109L13.5274 3.19845C13.1887 3.07786 12.9221 2.81131 12.8016 2.47257L12.5289 1.70668C12.3321 1.15367 11.7631 0.825167 11.1857 0.931186L10.3861 1.07802C10.0325 1.14296 9.66835 1.0454 9.39455 0.812325Z"
                  fill="#849DED"
                />
                <path
                  d="M12.5354 5.22656L6.30208 11.4399L3.46875 8.61565"
                  stroke="#3B5092"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M7.22451 0.285366C7.6715 -0.0951218 8.3285 -0.0951222 8.77549 0.285366L9.39455 0.812325C9.66835 1.04539 10.0325 1.14296 10.3861 1.07802L11.1857 0.931186C11.7631 0.825167 12.3321 1.15367 12.5289 1.70668L12.8016 2.47257C12.9221 2.81131 13.1887 3.07786 13.5274 3.19845L14.2933 3.47109C14.8463 3.66795 15.1748 4.23693 15.0688 4.81428L14.922 5.61388C14.857 5.96753 14.9546 6.33165 15.1877 6.60545L15.7146 7.22451C16.0951 7.6715 16.0951 8.3285 15.7146 8.77549L15.1877 9.39455C14.9546 9.66835 14.857 10.0325 14.922 10.3861L15.0688 11.1857C15.1748 11.7631 14.8463 12.3321 14.2933 12.5289L13.5274 12.8016C13.1887 12.9221 12.9221 13.1887 12.8016 13.5274L12.5289 14.2933C12.3321 14.8463 11.7631 15.1748 11.1857 15.0688L10.3861 14.922C10.0325 14.857 9.66835 14.9546 9.39455 15.1877L8.77549 15.7146C8.3285 16.0951 7.6715 16.0951 7.22451 15.7146L6.60545 15.1877C6.33165 14.9546 5.96753 14.857 5.61388 14.922L4.81428 15.0688C4.23693 15.1748 3.66795 14.8463 3.47109 14.2933L3.19845 13.5274C3.07786 13.1887 2.81131 12.9221 2.47257 12.8016L1.70668 12.5289C1.15367 12.3321 0.825167 11.7631 0.931185 11.1857L1.07802 10.3861C1.14296 10.0325 1.0454 9.66835 0.812325 9.39455L0.285366 8.77549C-0.0951218 8.3285 -0.0951222 7.6715 0.285366 7.22451L0.812325 6.60545C1.04539 6.33165 1.14296 5.96753 1.07802 5.61388L0.931186 4.81428C0.825167 4.23693 1.15367 3.66795 1.70668 3.47109L2.47257 3.19845C2.81131 3.07786 3.07786 2.81131 3.19845 2.47257L3.47109 1.70668C3.66795 1.15367 4.23693 0.825167 4.81428 0.931185L5.61388 1.07802C5.96753 1.14296 6.33165 1.0454 6.60545 0.812325L7.22451 0.285366Z"
                  fill="#C6C6C6"
                />
                <path
                  d="M7.70864 10.0036V7.62992H8.5982C9.20843 7.62992 9.65965 7.46827 9.95187 7.14498C10.2527 6.82169 10.4031 6.42608 10.4031 5.95816C10.4031 5.60934 10.33 5.31157 10.1839 5.06485C10.0378 4.80962 9.83155 4.61819 9.56511 4.49058C9.30727 4.35446 9.01075 4.2864 8.67555 4.2864C8.28878 4.2864 7.95359 4.36722 7.66996 4.52886C7.39493 4.682 7.18006 4.89469 7.02535 5.16694C6.87065 5.43068 6.79329 5.73696 6.79329 6.08577H5.60721C5.60721 5.58382 5.71895 5.11589 5.94241 4.682C6.17447 4.24811 6.51826 3.89504 6.97378 3.6228C7.42931 3.35055 7.99656 3.21443 8.67555 3.21443C9.27718 3.21443 9.79287 3.33779 10.2226 3.58451C10.6609 3.82273 10.9961 4.14602 11.2282 4.55439C11.4689 4.95425 11.5892 5.39665 11.5892 5.88159V6.03472C11.5892 6.51116 11.4732 6.9493 11.2411 7.34916C11.009 7.74902 10.6609 8.06806 10.1968 8.30628C9.7413 8.53598 9.17834 8.65084 8.50795 8.65084L8.97207 8.06381L8.94629 10.0036H7.70864ZM7.57971 12.7856V11.2287H9.07521V12.7856H7.57971Z"
                  fill="#767676"
                />
              </svg>
            )}
          </p>
          <p style={{ marginBottom: "0px" }}>
            {text.broadcast_status === "0"
              ? "Yet to start"
              : text.broadcast_status === "1"
              ? "In progress"
              : text.broadcast_status === "2"
              ? "Verification done"
              : "Yet to start"}
          </p>
          {/* </div> */}
        </div>
      ),
      ellipsis: {
        showTitle: false,
      },
      // render: (text) => (
      //   <span>
      //     <SoftBadge
      //       variant="contained"
      //       color={text.status === "sent" ? "seconday" : "dark"}
      //       size="xs"
      //       badgeContent={text.status === "sent" ? "Sent" : "Yet to send"}
      //       container
      //     />
      //   </span>
      //   // <Tooltip placement="topLeft" title={text.status}>
      //   //   {text.status}
      //   // </Tooltip>
      // ),
    },
    {
      title: "Action",
      // title: (
      //   // <SoftTypography fontWeight="large" fontSize="24px">
      //   //   ...
      //   // </SoftTypography>
      //   <MdMoreHoriz />
      // ),
      key: "operation",
      // fixed: "right",
      width: 100,
      // render: () => <MdMoreHoriz />,
      render: () => (
        <div className="edit_icons">
          <div className="dropdown">
            <Button
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <Icon icon="ion:ellipsis-horizontal" color="black" />
            </Button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <p
                  className="dropdown-item"
                  // href="#EditUser"
                  onClick={() => {
                    console.log("whatsapp verification modal");
                    setApplyModal(true);
                    // setStep2(true);
                  }}
                >
                  Whatsapp Verification
                </p>
              </li>
              <li>
                <p
                  className="dropdown-item"
                  // href="#Deleteuser"
                  onClick={() => {
                    console.log("counsellors modal");
                    // navigate("/search/newsearch/recommend-search/allshortlist/viewCandidates");
                  }}
                >
                  Counsellors
                </p>
              </li>
              <li>
                <p
                  className="dropdown-item"
                  // href="#Deleteuser"
                  onClick={() => {
                    console.log("sms verification");
                  }}
                >
                  SMS Verification
                </p>
              </li>
            </ul>
          </div>
        </div>
      ),
    },
  ];
  console.log(cosId);
  const sendMessageFunc = () => {
    console.log("JOb designation", jobdesignation);
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/candidatesearch/whatsappverification`,
        // "https://ee6e-2401-4900-6293-a5e8-fd29-5a11-4be5-a138.ngrok-free.app/superadmin/candidatesearch/whatsappverification",
        {
          // jobid: rowJobId,
          // candid: selectedRowKeys,
          // mobnum: rowMob,
          // name: rowName,
          // broadcastedby: orgId,
          broadcast_job: rowJobId,
          broadcast_cand: selectedRowKeys,
          broadcast_mobnum: rowMob,
          cand_name: rowName,
          job_designation: jobdesignation,
          broadcastedby: orgId,
        }
        //         {
        //     "broadcast_job": ["SMR-JOB-657149"],
        //     "broadcast_cand": ["SMR-JF-2312465"],
        //     "broadcast_mobnum": ["7977812652"],
        //     "cand_name": ["sanket"],
        //     "broadcastedby": "SMR-JP-747926",
        //     "job_designation": ["Advocate"]
        // }
        // {
        //   jobid: ["SMR-JOB-169429"],
        //   candid: ["SMR-JF-145353"],
        //   mobnum: ["6388166518"],
        //   name: ["sanket"],
        //   broadcastedby: "SMR-JP-114449",
        // }
      )
      .then((res) => {
        console.log(res.data);
        Swal.fire({
          icon: "success",
          title: "Success",
          // text: res.data["User Message"],
          text: "WhatsApp Message Queued",
          showConfirmButton: false,
          position: "top",
          timer: 3000,
        }).then(() => {
          navigate("/shortlisted");
        });
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: err.response.data["Developer Message"]
            ? err.response.data["Developer Message"]
            : "Oops...",
          // text: res.data["User Message"],
          text: err.response.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };
  // const handleSearch = () => {
  //   const newData = admindata.filter((ele) => {
  //     return name?.toLocaleLowerCase() === ""
  //       ? ele
  //       : ele.name?.toLocaleLowerCase().includes(name.toLocaleLowerCase()) ||
  //         name.toLocaleLowerCase() === ""
  //       ? ele
  //       : String(ele.mobnum).toLocaleLowerCase().includes(name.toLocaleLowerCase());
  //   });
  //   // .filter((y) => y.department == (department1 == "" ? y.department : department1))
  //   // .filter((z) => z.employement_type == (type1 == "" ? z.employement_type : type1));
  //   // setSearchData(newData);
  //   setSearchData(newData);
  // };
  // useEffect(() => {
  //   handleSearch();
  // }, [name]);

  return (
    <>
      <DashboardNavbar />
      <DashboardLayout>
        <SoftBox mt={2}>
          <SoftBox display="flex" flexDirection="column" alignItems="flex-start" p={0}>
            <SoftBox display="flex" flexDirection="row" justifyContent="space-between" width="100%">
              <SoftBox onClick={buttonFunc}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                >
                  <rect width="27" height="27" rx="13.5" fill="#D9D9D9" />
                  <path
                    d="M16.2008 18.9016L10.8008 13.5016L16.2008 8.10156"
                    stroke="black"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </SoftBox>
              <SoftTypography fontStyle="normal" fontWeight="medium" fontSize="24px">
                {`Shortlisted Candidates for \"${jobrole || localStorage_jobRole}\" `}
              </SoftTypography>
              <SoftBox display="flex" flexDirection="row" gap="10px">
                <SoftBox
                  sx={{
                    height: "40px",
                    backgroundColor: "#81BBFF",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  color="#fff"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                  width="68px"
                  /*
                  onClick={() => {
                    setactionModal(true);
                  }}
                  */
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <SoftTypography fontWeight="small" fontSize="14px" lineHeight="18px" color="#fff">
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="42"
                      height="36"
                      viewBox="0 0 42 36"
                      fill="none"
                    >
                      <rect width="42" height="36" rx="2" fill="white" />
                      <path
                        d="M10 18C10 18 14 10 21 10C28 10 32 18 32 18C32 18 28 26 21 26C14 26 10 18 10 18Z"
                        stroke="#A4A4A4"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21 21C22.6569 21 24 19.6569 24 18C24 16.3431 22.6569 15 21 15C19.3431 15 18 16.3431 18 18C18 19.6569 19.3431 21 21 21Z"
                        stroke="#A4A4A4"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg> */}
                    Action
                  </SoftTypography>
                </SoftBox>
                <Menu
                  sx={{ mt: 2 }}
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setApplyModal(true);
                      handleClose();
                    }}
                  >
                    Whatsapp Verification
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setactionModal1(true);
                      setactionModal(false);
                      handleConsPost();
                      handleClose();
                    }}
                  >
                    Counsellors
                  </MenuItem>
                  <MenuItem onClick={handleClose}>SMS Verification</MenuItem>
                </Menu>
                {/* {step2 && ( */}
                <SoftBox
                  sx={{
                    height: "40px",
                    //backgroundColor: "#81BBFF",
                    //borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                  // width="117px"
                  //color="#fff"
                >
                  {/* <Card sx={{ overflow: "hidden", backgroundColor: "#81BBFF" }}> */}
                  <Select
                    options={viewList}
                    placeholder="View List"
                    styles={stylesDD}
                    //fontWeight="small"
                    //fontSize="14px"
                    //lineHeight="18px"
                    onChange={(e) => {
                      {
                        e.value === "Whatsapp List"
                          ? (setStep2(true), setStep1(false), setStep3(false))
                          : e.value === "All"
                          ? (setStep2(false), setStep1(true), setStep3(false))
                          : (setStep2(false), setStep1(false), setStep3(true));
                      }
                    }}
                  />
                  {/* </Card> */}
                </SoftBox>
                {/* )} */}

                {/*
                <SoftBox
                  sx={{
                    height: "40px",
                    backgroundColor: "#FFF",
                    borderRadius: "2px",
                    cursor: "pointer",
                  }}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                  width="40px"
                >
                  <SoftBox>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="38"
                      height="38"
                      viewBox="0 0 38 38"
                      fill="none"
                    >
                      <rect width="38" height="38" rx="2" fill="white" />
                      <path
                        d="M28 22V26C28 26.5304 27.7893 27.0391 27.4142 27.4142C27.0391 27.7893 26.5304 28 26 28H12C11.4696 28 10.9609 27.7893 10.5858 27.4142C10.2107 27.0391 10 26.5304 10 26V22"
                        stroke="#A4A4A4"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14 17L19 22L24 17"
                        stroke="#A4A4A4"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M19 22V10"
                        stroke="#A4A4A4"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SoftBox>
                </SoftBox>
                */}
                <SoftBox
                  sx={{
                    height: "40px",
                    backgroundColor: "#FFF",
                    borderRadius: "2px",
                    cursor: "pointer",
                  }}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                  width="40px"
                  mr={2}
                  onClick={() =>
                    handleShortlistedApi(registerID, jobrole, searchParams.get("job_id"))
                  }
                >
                  <SoftBox>
                    <img src={refreshBtn} />
                  </SoftBox>
                </SoftBox>
                {/* <SoftBox sx={{ height: "40px", backgroundColor: "#FFF", borderRadius: "2px", cursor:"pointer" }} 
                                      display="flex" justifyContent="center" alignItems="center"
                                      // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                                      width="40px"
                                  >
                                    <SoftBox>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                                      <rect width="38" height="38" rx="5" fill="white"/>
                                      <path d="M26.3333 28.1673H11.6667C11.4236 28.1673 11.1904 28.0707 11.0185 27.8988C10.8466 27.7269 10.75 27.4938 10.75 27.2507V10.7507C10.75 10.5075 10.8466 10.2744 11.0185 10.1025C11.1904 9.93056 11.4236 9.83398 11.6667 9.83398H26.3333C26.5764 9.83398 26.8096 9.93056 26.9815 10.1025C27.1534 10.2744 27.25 10.5075 27.25 10.7507V27.2507C27.25 27.4938 27.1534 27.7269 26.9815 27.8988C26.8096 28.0707 26.5764 28.1673 26.3333 28.1673ZM25.4167 26.334V11.6673H12.5833V26.334H25.4167ZM15.3333 14.4173H22.6667V16.2507H15.3333V14.4173ZM15.3333 18.084H22.6667V19.9173H15.3333V18.084ZM15.3333 21.7507H22.6667V23.584H15.3333V21.7507Z" fill="#A4A4A4"/>
                                      </svg>
                                    </SoftBox>
                    </SoftBox >
                    <SoftBox  sx={{ height: "40px", backgroundColor: "#FFF", borderRadius: "2px", cursor:"pointer" }} 
                                      display="flex" justifyContent="center" alignItems="center"
                                      // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                                      width="40px"
                                      
                                  >
                                      <SoftBox >
                                          <svg xmlns="http://www.w3.org/2000/svg" width="39" height="37" viewBox="0 0 39 37" fill="none">
                                              <rect width="38.8889" height="37" rx="2" fill="white"/>
                                              <path d="M28.8889 10H10L17.5556 18.9344V25.1111L21.3333 27V18.9344L28.8889 10Z" stroke="#A4A4A4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                          </svg>
                                      </SoftBox>
                    </SoftBox > */}
              </SoftBox>
            </SoftBox>
            <Grid container>
              <SoftBox width="100%" mt={3}>
                <Grid container>
                  <SoftBox display="flex" flexDirection="row" justifyContent="space-between">
                    <SoftBox display="flex" flexDirection="row" gap="20px">
                      <Grid item>
                        <SoftInput type="text" placeholder="Role" width="274px" />
                      </Grid>
                      <Grid item>
                        <SoftInput type="text" placeholder="Score" width="274px" />
                      </Grid>
                      <Grid item>
                        <SoftBox
                          width="85px"
                          height="40px"
                          p="10px 20px"
                          sx={{ backgroundColor: "#3B5092", borderRadius: "10px" }}
                        >
                          <SoftTypography
                            fontWeight="small"
                            fontSize="15px"
                            lineHeight="19px"
                            sx={{ color: "#fff" }}
                          >
                            Apply
                          </SoftTypography>
                        </SoftBox>
                      </Grid>
                    </SoftBox>
                    {/* <SoftBox width={{ lg: "500px", md: "400px" }}>
                      <SoftInput
                        isClearable
                        // width={{ lg: "1000px", md: "600px" }}
                        // width="1000px"
                        id="search-bar"
                        className="text"
                        // onInput={(e) => {
                        //   setSearchQuery(e.target.value);
                        // }}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        variant="outlined"
                        placeholder="Search by name and contact number"
                        size="small"
                      />
                    </SoftBox> */}
                  </SoftBox>
                </Grid>
              </SoftBox>
            </Grid>
            <Grid container>
              <SoftBox mt={3} width="1200px">
                {step1 && (
                  <Table
                    loading={isLoading}
                    // {...tableProps}
                    //  pagination={{position:["bottomCenter"]}}
                    rowSelection={rowSelection}
                    columns={columns2}
                    dataSource={data}
                    // dataSource={candidateTable}
                    scroll={{ x: 2000 }}
                    style={{ zIndex: "0 !important" }}
                  />
                )}

                {step2 && (
                  <Table
                    // {...tableProps}
                    //  pagination={{position:["bottomCenter"]}}
                    loading={isLoading}
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={shortData
                      .filter((ele) => ele.broadcast_status === "1")
                      // .filter((ele) => ele.broadcasted === "1")
                      .map((item) => ({
                        ...item,
                        mobile: item.mobile.substring(0),
                        last_activedate: moment(item.last_activedate).format("DD-MM-YYYY"),
                        modifieddt: moment(item.modifieddt).format("DD-MM-YYYY"),
                        job_title: item.job_title,
                      }))}
                    // dataSource={candidateTable}
                    scroll={{ x: 2000 }}
                  />
                )}

                {step3 && (
                  <Table
                    // {...tableProps}
                    //  pagination={{position:["bottomCenter"]}}
                    loading={shortData?.length === 0 ? true : false}
                    rowSelection={rowSelection}
                    columns={columns3}
                    dataSource={shortData
                      .filter((ele) => ele.counsellor_name !== "")
                      .map((item) => ({ ...item, mobile: item.mobile.substring(0) }))}
                    // dataSource={candidateTable}
                    scroll={{ x: 2000 }}
                  />
                )}
              </SoftBox>
            </Grid>
          </SoftBox>
        </SoftBox>
      </DashboardLayout>
      {/* Modal 1 */}
      <Modal
        show={actionModal1}
        onHide={() => {
          setactionModal1(false);
          // showAlert();
        }}
        size="sm"
        centered
      >
        <Modal.Header closeButton>Assign Counsellor</Modal.Header>

        <Modal.Body>
          <SoftTypography
            sx={{ color: "black", fontSize: "15px", fontWeight: "medium", lineHeight: "19px" }}
          >
            Select Counsellor
          </SoftTypography>
          <SoftBox display="flex" flexDirection="column">
            <SoftSelect
              placeholder="Select Counsellor"
              options={cosList}
              value={cosId}
              onChange={(e) =>
                // jobpostform.setFieldValue("org_name", e.label),
                setCosId(e)
              }
            />
          </SoftBox>
        </Modal.Body>
        <Modal.Footer className="apply-modal">
          <SoftBox
            // pl={2}
            sx={{
              height: "45px",
              backgroundColor: "#3B5092",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
            width={{ lg: "225px", sm: "100%", xs: "50%" }}
            onClick={() => {
              // setApplyModal(true);
              setactionModal1(false);
              handleConsPostData();
              // setStep1(false);
              // setStep2(true);
              // Swal.fire()
            }}
          >
            <SoftTypography
              display="flex"
              justifyContent="center"
              sx={{ color: "#fff", fontSize: "15px", fontWeight: "medium", lineHeight: "19px" }}
            >
              Apply
            </SoftTypography>
          </SoftBox>
        </Modal.Footer>
      </Modal>
      {/* Modal 1 */}
      <Modal
        show={actionModal}
        onHide={() => {
          setactionModal(false);
          // showAlert();
        }}
        size="sm"
        centered
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          <SoftBox display="flex" flexDirection="column">
            <SoftBox
              // pl={2}
              sx={{
                // height: "45px",
                // backgroundColor: "#3B5092",
                // borderRadius: "5px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
              }}
              // p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
              // width={{ lg: "225px", sm: "100%", xs: "50%" }}
              onClick={() => {
                setApplyModal(true);
                setactionModal(false);
                // setStep1(false);
                // setStep2(true);
              }}
            >
              <SoftButton my="14px" display="flex" justifyContent="center">
                <SoftTypography>Whatsapp Verification</SoftTypography>
              </SoftButton>
            </SoftBox>
            <SoftBox
              // pl={2}
              sx={{
                // height: "45px",
                // backgroundColor: "#3B5092",
                // borderRadius: "5px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
              }}
              // p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
              // width={{ lg: "225px", sm: "100%", xs: "50%" }}
              onClick={() => {
                setactionModal1(true);
                setactionModal(false);
                handleConsPost();
                // setStep1(false);
                // setStep2(true);
              }}
            >
              <SoftButton my="14px" display="flex" justifyContent="center">
                <SoftTypography>Counsellors</SoftTypography>
              </SoftButton>
            </SoftBox>

            <SoftButton my="14px" display="flex" justifyContent="center">
              <SoftTypography>SMS Verification</SoftTypography>
            </SoftButton>
          </SoftBox>
        </Modal.Body>
        {/* <Modal.Footer className="apply-modal">
          <SoftBox
            // pl={2}
            sx={{
              height: "45px",
              backgroundColor: "#3B5092",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
            width={{ lg: "225px", sm: "100%", xs: "50%" }}
            onClick={() => {
              setApplyModal(true);
              setactionModal(false);
              // setStep1(false);
              // setStep2(true);
            }}
          >
            <SoftTypography
              display="flex"
              justifyContent="center"
              sx={{ color: "#fff", fontSize: "15px", fontWeight: "medium", lineHeight: "19px" }}
            >
              Apply
            </SoftTypography>
          </SoftBox>
        </Modal.Footer> */}
      </Modal>

      {/* Modal 2 */}
      <Modal
        show={applyModal}
        onHide={() => {
          setApplyModal(false);
          // showAlert();
        }}
        centered
      >
        <Modal.Header closeButton>
          <SoftBox display="flex" justifyContent="center">
            <SoftTypography fontWeight="medium" fontSize="16px" lineHeight="20px">
              Candidate Connect Message
            </SoftTypography>
          </SoftBox>
        </Modal.Header>

        <Modal.Body>
          <SoftBox display="flex" flexDirection="column">
            {/* <SoftBox display="flex" justifyContent="center" mt="20px" mb="15px">
              <SoftTypography fontWeight="medium" fontSize="16px" lineHeight="20px">
                Candidate connect message
              </SoftTypography>
            </SoftBox> */}
            <SoftBox display="flex" flexDirection="column" justifyContent="center">
              <SoftTypography fontWeight="small" fontSize="14px" lineHeight="19px">
                Dear Candidate,
              </SoftTypography>
              <SoftTypography fontWeight="medium" fontSize="16px" lineHeight="20px">
                Greetings from SAMARTH
              </SoftTypography>
              <SoftTypography fontWeight="small" fontSize="14px" lineHeight="19px">
                Based on our evaluation of your skills, we have been assigned by your local public
                administrator to help you with your job search. We have identified job requirements
                that may suit your requirements. Are you actively looking for new job opportunities?
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </Modal.Body>
        <Modal.Footer className="apply-modal">
          <SoftBox
            // pl={2}
            sx={{
              height: "45px",
              backgroundColor: "#3B5092",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
            width={{ lg: "225px", sm: "100%", xs: "50%" }}
            onClick={() => {
              setApplyModal(false);
              setStep1(false);
              setStep2(true);
              sendMessageFunc();
            }}
          >
            <SoftTypography
              display="flex"
              justifyContent="center"
              sx={{ color: "#fff", fontSize: "15px", fontWeight: "medium", lineHeight: "19px" }}
            >
              Send
            </SoftTypography>
          </SoftBox>
        </Modal.Footer>
      </Modal>
      {/* Modal 2 */}
    </>
  );
};
ViewCandidates.propTypes = {
  orgname: PropTypes.string.isRequired,
  jobrole: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  buttonFunc: PropTypes.func.isRequired,
  orgId: PropTypes.string.isRequired,
  jobId: PropTypes.string.isRequired,
  shortData: PropTypes.array.isRequired,
  setShortData: PropTypes.array.isRequired,
  handleShortlistedApi: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  // h4: PropTypes.string.isRequired,
  // v1: PropTypes.string.isRequired,
  // v2: PropTypes.string.isRequired,
  // v3: PropTypes.string.isRequired,
  // v4: PropTypes.string.isRequired,
};
export default ViewCandidates;
